import { ORGANIZATION_ATTACH_ORG_ID, ORGANIZATION_UPDATE, ORGANIZATION_SWITCH } from '.';
import organizationServiceApi from '../../api/organization.service.api';

export const updateOrganization = () => async dispatch => {
  let { data, error } = await organizationServiceApi.me();

  if (error) {
    return false;
  }

  dispatch({
    type: ORGANIZATION_UPDATE,
    payload: data,
  });
};

export const switchOrganization =
  ({ id }) =>
  async dispatch => {
    let { data, error } = await organizationServiceApi.switch({ id });

    if (error) {
      return false;
    }

    dispatch({
      type: ORGANIZATION_SWITCH,
      payload: data,
    });
  };

export const organizationAttachId = ({ id }) => ({
  type: ORGANIZATION_ATTACH_ORG_ID,
  payload: { id },
});
